




















import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { RssCSS } from "@/services/posts/postTypes/rss";

@Component
export default class RssStyle extends Vue {
    @Prop() private itemStyle!: Style;

    get model(): RssCSS {
        return this.itemStyle.css
            ? (this.itemStyle.css as RssCSS)
            : ({} as RssCSS);
    }
}
